import { createAction } from '../../libs/saga-utils';

const ns = 'emailTemplateTypes';

export const EMAIL_TEMPLATE_TYPES_TYPES = {
  LOAD_ALL_REQUEST: `${ns}/LOAD_ALL_REQUEST`,
  LOAD_ALL_SUCCESS: `${ns}/LOAD_ALL_SUCCESS`,
  LOAD_ALL_FAILURE: `${ns}/LOAD_ALL_FAILURE`,

  UPDATE_FILTERS: `${ns}/UPDATE_FILTERS`,
  RESET_ERRORS: `${ns}/RESET_ERRORS`,
  RESET_ACTIVE: `${ns}/RESET_ACTIVE`
};

export const EMAIL_TEMPLATE_TYPES_ACTIONS = {
  loadAllRequest: createAction(EMAIL_TEMPLATE_TYPES_TYPES.LOAD_ALL_REQUEST),
  loadAllSuccess: createAction(
    EMAIL_TEMPLATE_TYPES_TYPES.LOAD_ALL_SUCCESS,
    emailTemplateTypes => ({
      emailTemplateTypes
    })
  ),
  loadAllFailure: createAction(
    EMAIL_TEMPLATE_TYPES_TYPES.LOAD_ALL_FAILURE,
    error => ({ error })
  ),

  updateFilters: createAction(
    EMAIL_TEMPLATE_TYPES_TYPES.UPDATE_FILTERS,
    filters => ({ filters })
  ),
  resetErrors: createAction(EMAIL_TEMPLATE_TYPES_TYPES.RESET_ERRORS),
  resetActive: createAction(EMAIL_TEMPLATE_TYPES_TYPES.RESET_ACTIVE)
};
